/* @flow */
import React, { useRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { getViewedStock } from "../../../redux/reducer/tabs";
import Gettext from "../../common/Gettext";
import Mobile from "../../layout/Mobile";

import StockMenu from "../../StockMenu";
import Popup from "../Popup";

import type { Dispatch } from "../../../redux/action";
import type { State as Settings } from "../../../redux/reducer/settings";
import type { State as Tabs } from "../../../redux/reducer/tabs";
import Tour from "../../Tour";

type Props = {
  dispatch: Dispatch,
  history: Object,
  location: Object,
  match: Object,
  onClick: () => void
};

type State = {
  settings: Settings,
  tabs: Tabs,
  activeStock: string
};

let Assets = (props: Props) => {
  let original = useRef(null);

  return (
    <Mobile>
      <Tour step={["allStocksSelect"]} disabled originalRef={original} withoutStyles={true}>
        {({ next, isOriginal, isTourActive, step }) => (
          <Popup
            ref={isOriginal ? original : null}
            title={<Gettext>Asset</Gettext>}
            onClick={props.onClick}
            isTour={!isOriginal}
          >
            <StockMenu
              isTour={!isOriginal}
              defaultCategory={isTourActive ? "popular" : null}
              onStockSelect={stock => {
                next(stock);
                props.dispatch({
                  type: "SET_ACTIVE_STOCK",
                  payload: {
                    newStock: stock,
                    activeStock: props.activeStock
                  }
                });
                if (!/sightseeing/.test(props.location.pathname)) {
                  props.history.replace("/trade");
                } else {
                  props.history.replace("/sightseeing");
                }
              }}
              onClose={isOriginal ? props.onClick : null}
            />
          </Popup>
        )}
      </Tour>
    </Mobile>
  );
};

export default withRouter(
  connect((state: State) => ({
    settings: state.settings,
    activeStock: getViewedStock(state.tabs)
  }))(props => <Assets {...props} />)
);



// WEBPACK FOOTER //
// ./src/components/TradeMobile/Toolbar/Assets.js